module.exports = __webpack_public_path__ + "static/media/accountimg.7a4bbd8d.svg";